const SetCookie = (cookieName, newValue) => {
    document.cookie=cookieName+'='+newValue+'; path=/'
};

export default SetCookie;